export default {"src":"/_next/static/media/icone-potential.11428d54.svg","height":18,"width":32,"blurWidth":0,"blurHeight":0};